import { CommentDataSourceService } from './../../core/data-sources/comment-data-source.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CratesDataSourceService } from '../../../app/core/data-sources/crates-data-source.service';
import { StockDetailsInterface } from '../../../app/modals/stock-details-modal/stock-details-modal.component';
import { CrateType } from '../../../models/Crate';
import { ActionService } from 'src/app/core/services/action.service';
import { ErrorService } from 'src/app/core/services/error.service';

@Component({
  selector: 'app-map-pallet-details',
  templateUrl: './map-pallet-details.component.html',
  styleUrls: ['./map-pallet-details.component.scss']
})
export class MapPalletDetailsComponent implements OnInit {
  @Input() public data: StockDetailsInterface;
  @Output() relocateClicked = new EventEmitter();
  @Output() palletInventoryClicked = new EventEmitter();
  selected = new FormControl(0);
  isDestinyChange = false;
  remainsPalletWarning: string | null = null;
  loadEventTab = false;
  isNavigatedPallet = false;
  previousPalletData: StockDetailsInterface | null = null;

  constructor(
    private commentDataSource: CommentDataSourceService,
    private crateDataSourceService: CratesDataSourceService,
    private actionService: ActionService,
    private errorService: ErrorService
  ) { }

  ngOnInit(): void {
    this.onSelectedIndexChange(this.data.page);
    this.data.itemDetails.comments = this.data.itemDetails.comments.filter((comment)=> !(comment.deletedAt != 0));
    this.remainsPalletWarning = this.data.item.type === CrateType.REMAINS ? `O histórico abaixo refere-se ao palete original (RFID: ${this.data.itemDetails.crate.parents?.[0]?.tagRfid}), do qual este fracionado foi originado.` : null;
    this.isNavigatedPallet = false;
    this.previousPalletData = null;
  }

  onSelectedIndexChange(index: number) {
    this.selected.setValue(index);
    this.loadEventTab = index === 1;
  }

  onRelocateClicked(event) {
    this.relocateClicked.emit(event);
  }

  onInventoryClicked(event) {
    this.palletInventoryClicked.emit(event);
  }

  async submitComment(event) {
    try {
      await this.commentDataSource.postStockComment(this.data.itemDetails.crate.skuGroups[0].crateId, event.comment, 'STORED');
    } catch (e) {
      console.log(e);
    } finally {
      await this.update();
    }
  }

  async deleteComment(event) {
    try {
      await this.commentDataSource.deleteStockComment(this.data.itemDetails.crate.skuGroups[0].crateId, event);
    } catch (e) {
      console.log(e);
    } finally {
      await this.update();
    }
  }

  async update() {
    this.data.itemDetails = await this.crateDataSourceService.getCrateById(this.data.itemDetails.crate.id).then((r: any) => {
      r.invoice = r.crate.invoices[0];
      return r;
    });
  }

  
  async handleSetUnderAlert(crateId: string) {
    try {
      await this.actionService.setPalletUnderAlert({ crateId, deviceName: 'ADM' });
      await this.update();
    } catch (e) {
      this.errorService.openErrorSnackBar(e);
    }
  }

  async handleUnsetUnderAlert(crateId: string) {
    try {
      await this.actionService.unsetPalletUnderAlert({ crateId, deviceName: 'ADM' });
      await this.update();
    } catch (e) {
      this.errorService.openErrorSnackBar(e);
    }
  }

  handleOpenPalletDetails(palletData) {
    this.previousPalletData = { ...this.data };
    this.data = palletData;
    this.data.itemDetails.comments = this.data.itemDetails.comments.filter((comment)=> !(comment.deletedAt != 0));
    this.remainsPalletWarning = this.data.item.type === CrateType.REMAINS ? `O histórico abaixo refere-se ao palete original (RFID: ${this.data.itemDetails.crate.parents?.[0]?.tagRfid}), do qual este fracionado foi originado.` : null;
    this.isNavigatedPallet = true;
    this.selected.setValue(0);
    this.loadEventTab = false;
  }

  goBackToPreviousPallet() {
    if (this.previousPalletData) {
      this.data = this.previousPalletData;
      this.remainsPalletWarning = this.data.item.type === CrateType.REMAINS ? `O histórico abaixo refere-se ao palete original (RFID: ${this.data.itemDetails.crate.parents?.[0]?.tagRfid}), do qual este fracionado foi originado.` : null;
      this.selected.setValue(1);
      this.loadEventTab = true;
      this.isNavigatedPallet = false;
      this.previousPalletData = null;
    }
  }

}
